import { Base } from 'layouts'

import * as S from './styled'
import { IndustryCertificateDetails as IndustryCertificateDetailsComponent } from 'components/IndustryCertificate'

export function IndustryCertificateDetails() {
  return (
    <Base>
      <S.GridContainer container>
        <IndustryCertificateDetailsComponent />
      </S.GridContainer>
    </Base>
  )
}
